import React from 'react'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import DatePickerFormItem from 'components/Common/ElementInForm/DatePickerFormItem';
import NativeTimePicker from 'components/Common/ElementInForm/NativeTimePicker';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import TimePickerFormItem from 'components/Common/ElementInForm/TimePickerFormItem';

const OptionIsNoticeEmail = [
    { value: "1", label: "ส่ง" },
    { value: "0", label: "ไม่ส่ง" },
]

const CpnDataProductService = (props) => {

    const {
        form,
        header,
        setIsCheckTel,
        IsCheckTel,
        Option,
        lstPrd_BA,
        onHandleField,
        nStatusID,
        sMode,
        sCustomerType,
        setisInputTelRequireGuest,
        IsAddTelExtentionGuest,
        setIsAddTelExtentionGuest,
    } = props;

    return (
        <>
            <Accordion header={header}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                    <Grid item xs={12}>
                        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="start" >
                            <Grid item xs={12} sm={3}>
                                <InputFormItem
                                    id="sJobCode"
                                    name="sJobCode"
                                    label="เลขที่ใบงาน"
                                    required={false}
                                    fullWidth
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="start" >
                                    <Grid item xs={12} sm={6}>
                                        <InputFormItem
                                            id="sVOCFormCode"
                                            name="sVOCFormCode"
                                            label="เลขที่ใบแจ้ง"
                                            required={false}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {
                            sCustomerType == "P" ?
                                <>
                                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                        <Grid item xs={12} sm={6}>
                                            <InputFormItem
                                                id="sFname"
                                                name="sFname"
                                                label="ชื่อ"
                                                required={true}
                                                fullWidth
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <InputFormItem
                                                id="sLname"
                                                name="sLname"
                                                label="นามสกุล"
                                                required={true}
                                                fullWidth
                                                disabled={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                                :
                                <>
                                    <AsyncAutoComplete
                                        name="oCustomer"
                                        sUrlAPI={"User/SearchUser"}
                                        label="ลูกค้า"
                                        required={true}
                                        textSearch={"กรอกชื่อลูกค้า/นามสกุลลูกค้า"}
                                        sMethodAxios={"POST"}
                                        disabled={true}
                                        onChange={(event) => {
                                            onHandleField(event, "Customer")
                                        }}
                                    />
                                </>
                        }

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oBA"
                            options={lstPrd_BA ?? []}
                            label={"กลุ่มตลาด"}
                            required={true}
                            disabled={sMode === "view" || [3, 4, 5, 7, 8, 19, 20].includes(nStatusID)}
                            onChange={(event) => {
                                onHandleField(event, "BA");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {
                            sCustomerType == "P" ?
                                <>
                                    <InputFormItem
                                        id="sCompany"
                                        name="sCompany"
                                        label="บริษัท"
                                        required={true}
                                        fullWidth
                                        disabled={true}
                                    />
                                </>
                                :
                                <>
                                    <AutoCompleteSelect
                                        name="oCompany"
                                        options={Option.lstCompany ?? []}
                                        label={"บริษัท"}
                                        required={true}
                                        disabled={true}
                                        onChange={(event) => {
                                            onHandleField(event, "Company")
                                        }}
                                    />
                                </>
                        }

                    </Grid>
                    <Grid item xs={12}>
                        {
                            sCustomerType == "P" ?
                                <>
                                    <InputFormItem
                                        id="sAddress"
                                        name="sAddress"
                                        label="ที่อยู่"
                                        required={true}
                                        fullWidth
                                        disabled={true}
                                    />
                                </>
                                :
                                <>
                                    <AutoCompleteSelect
                                        name="oAddress"
                                        options={Option.lstCompanyAddress ?? []}
                                        label={"ที่อยู่/สถานที่เกิดเหตุ"}
                                        required={true}
                                        disabled={true}
                                    />
                                </>
                        }
                    </Grid>
                    <Grid item xs={12} >
                        <InputCustomLabel
                            id="sDetail"
                            name="sDetail"
                            label="รายละเอียด"
                            required={true}
                            disabled={true}
                            multiline={true}
                            maxLength={1000}
                            rows={4}
                            fullWidth
                        />
                    </Grid>
                    {
                        sCustomerType == "P" ?
                            <>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputFormItem
                                        id="sInputTel"
                                        name="sInputTel"
                                        label="หมายเลขโทรศัพท์"
                                        required={false}
                                        fullWidth
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={'auto'}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={IsAddTelExtentionGuest}
                                            />
                                        }
                                        label={"เบอร์ต่อ"}
                                        disabled={true}
                                        labelPlacement="end"
                                    />
                                </Grid>
                                {IsAddTelExtentionGuest === true &&
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputCustomLabel
                                            id="sInputTelExtension"
                                            name="sInputTelExtension"
                                            label="เบอร์ต่อ"
                                            disabled={true}
                                            required={false}
                                            fullWidth
                                        />
                                    </Grid>
                                }
                            </>
                            :
                            <>
                                <Grid item xs={12} sm={6}>
                                    <AutoCompleteSelect
                                        name="oTel"
                                        options={Option.lstTel ?? []}
                                        label={"หมายเลขโทรศัพท์"}
                                        required={true}
                                        disabled={true}
                                    />
                                </Grid>
                            </>
                    }

                    <Grid item xs={12} sm={6} md={4.5}>
                        <InputFormItem
                            id="sEmail"
                            name="sEmail"
                            label="อีเมล"
                            required={true}
                            disabled={true}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '-16px' }}>
                        <FormControlLabel
                            disabled={true}
                            control={
                                <Checkbox
                                    checked={IsCheckTel}
                                    onChange={() => {
                                        // setIsOpenMap(true)
                                        setIsCheckTel(!IsCheckTel);
                                    }}
                                />
                            }
                            label="ยินดีให้ติดต่อกลับทางโทรศัพท์"
                            labelPlacement="end"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                            <Grid item xs={12} sm={6} md={5}>
                                <DatePickerFormItem
                                    name="sDateIssue"
                                    label="วันที่แจ้ง"
                                    fullWidth={true}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={5}>
                                <TimePickerFormItem
                                    name="sTimeIssue"
                                    label="เวลาที่แจ้ง"
                                    fullWidth={true}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Accordion>
        </>
    )
}

export default CpnDataProductService